// extracted by mini-css-extract-plugin
module.exports = {"image":"SolutionHeader_image__GmUdX"};